export default __webpack_public_path__ + "static/media/hardhatparrot.f0cb9328.gif";